import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [token, setToken] = useState("");
  const [pw, setPw] = useState("");
  const nav = useNavigate();
  async function submit(e) {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset. Sign in.");
      nav("/login");
    } catch (err) { toast.error(formatErr(err.response?.data?.detail) || "Failed"); }
  }
  return (
    <div className="min-h-screen grid place-items-center p-6 grain">
      <Card className="w-full max-w-md bg-[hsl(224_45%_9%)] border-border p-8 relative z-10">
        <h2 className="font-display text-3xl font-bold mb-1">Reset password</h2>
        <p className="text-sm text-muted-foreground mb-6">Paste your reset token to set a new password.</p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label className="text-xs uppercase text-muted-foreground">Token</Label>
            <Input required value={token} onChange={(e) => setToken(e.target.value)} data-testid="rp-token" className="mt-1.5 h-11 bg-[hsl(224_40%_12%)]"/></div>
          <div><Label className="text-xs uppercase text-muted-foreground">New password</Label>
            <Input required type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="rp-password" className="mt-1.5 h-11 bg-[hsl(224_40%_12%)]"/></div>
          <Button data-testid="rp-submit" className="w-full h-11 bg-amber-500 text-[hsl(224_60%_6%)] hover:bg-amber-400 font-semibold">Set new password</Button>
        </form>
        <div className="mt-5 text-xs text-center text-muted-foreground">
          <Link to="/login" className="text-amber-400 hover:underline">Back to sign in</Link>
        </div>
      </Card>
    </div>
  );
}
